import { defineAsyncComponent } from "vue";
export default [
  {
    name: "AssessmentMonitor",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/monitoring/Monitoring"),
    ),
    path: "",
    props: (route) => ({ query: route.query }),
  },
  {
    name: "AssessmentMonitorAggregateAttemptView",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/aggregate-attempt/AggregateAttempt"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:activityId/component/:componentId/question/:questionUuid/aggregate-attempt",
    props: true,
  },
  {
    name: "AssessmentMonitorAggregateQuizAttempt",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/aggregate-attempt/AggregateQuizAttempt.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/aggregate-attempt",
    props: true,
  },
  {
    name: "AssessmentMonitorAbilitySnapshot",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/monitoring/AdaptiveSectionMonitoring.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/ability-snapshot",
    props: true,
  },
];
